<template>
  <div class="container is-fluid">
      <div class="columns" style="font-family: Helvetica">
        <div class="column is-three-fifths">
          <section id="about-anchor" ref="about-anchor" class="hero">
            <div class="hero-body">
              <p class="title has-text-white">Stories</p>
              <p class="subtitle has-text-white">
                Stories and anecdotes
              <ul>
              <li><a v-on:click="scrollToAnchorPoint('space')" >Italian Cuisine in Space</a></li>
              <li><a v-on:click="scrollToAnchorPoint('fimo')">F.I.M.O.</a></li>
              <li><a v-on:click="scrollToAnchorPoint('miami')">Miami Home</a></li>
              <li><a v-on:click="scrollToAnchorPoint('pope')">Chat with Pope Francis</a></li>
              </ul>
              </p>
            </div>
          </section>
        </div>
      </div>
      <div class="columns">
      <div class="column">
            <h1 id="space" ref="space">
                Italian food in space
            </h1>
            <br/><br/><br/><br/><br/>
          <h2 class="abouttext">
            <h3>
            "Emanuele Viscuso, Delegate in Florida of the Accademia Italiana della Cucina ( www.accademiaitalianacucina.it ), 
            is the organizer of the first official Italian Dinner in the Space."
            Emanuele Viscuso has taken part to the Esperia* STS-120/10A Mission,
             launched on 23 October 2007 from the NASA’s Kennedy Space Centre, 
             in Florida as delegate in Florida of Accademia Italiana della Cucina, 
             a Cultural Institution of the Italian Republic. Thanks to his proposal and support, 
             onboard the Space Shuttle Discovery, Node 2 - the interconnecting unit developed in 
             Italy by Thales Alenia Space - and the ESA, the Italian Paolo Nespoli and other astronauts 
             started their journey towards the International Space Station (ISS) bringing with
              them delicious Italian food to offer to the other astronauts on the Station in orbit.
               Thanks to the importance of Accademia Italiana della Cucina this can be considered the 
               first Space Convivium in the history. The Accademia awarded Emanuele Viscuso for this
                remarcable work with the Ettore Pepe Award in Palermo, Sicily on September 8, 2008
            </h3>
          </h2>
        </div>
        <div class="column" style="min-height: 500px">
          <img
          class="bigimage"
            src="nasa/meal_2.jpg"
            alt="Emanuele Viscuso"
            align="left"
            style="margin: 50px 20px"
          /><br />
          <img
          class="midimage"
            v-prlx="{
              mobileMaxWidth: 500,
              speed: 0.2,
              fromBottom: false,
              preserveInitialPosition: true,
            }"
            src="nasa/meal_6.jpg"
            alt="Emanuele Viscuso"
            align="left"
            contain
            style="margin: -100px 0px"
          />
          <img
          class="bigimage"
            src="nasa/meal_8.jpg"
            alt="Emanuele Viscuso"
            align="right"
            contain
            style="margin: 10px -20px"
          /><br />
          <br />
        </div>
    </div>
    <div class="columns">
     
        <div class="column" style="min-height: 700px">
          <img
          class="bigimage"
            src="loghi/Logo Fimo.jpg"
            alt="Emanuele Viscuso"
            align="left"
            style="margin: 50px 20px"
          /><br />
          <img
          class="midimage"
            v-prlx="{
              mobileMaxWidth: 500,
              speed: 0.2,
              fromBottom: false,
              preserveInitialPosition: true,
            }"
            src="images/FimoPhoto.jpg"
            alt="Emanuele Viscuso"
            align="left"
            contain
            style="margin: -100px 0px"
          />
          <img
          class="bigimage"
            src="loghi/SICILIAN fILM fESTIVAL CON SCRITTA 2.jpg"
            alt="Emanuele Viscuso"
            align="right"
            contain
            style="margin: 10px -20px"
          /><br />
          <br />

        </div>
         <div class="column">
            <h1 id="fimo" ref="fimo">
                Sicilian Film Festival F.I.M.O
            </h1>
            <br/><br/><br/><br/><br/>
          <h2 class="abouttext">
            <h3>
            <a href="http://www.sicilianfilmfestival.com/" target="_blank">Visit the website</a>
            <br/>
            For the first time, Sicilian Cinema is making a name for itself thanks to the Sicilian Film Festival (SFF).  The seven-day Festival was created in Miami in 2006 by the Sicilian-born sculptor, musician, writer, and designer Emanuele Viscuso. Now residing in Miami Beach, Viscuso seeks to underline the importance of Sicily, its cinema, literature, art, food and wine, fashion, and culture on an international platform.


            The SFF has created renewed pride, not only among Sicilians, but all Italians living around the world. It is the first organization to showcase:
            Sicily’s importance in film production (it is second in Italy, after Rome, in producing movies);
            some of the best Italian directors including Sicilian, Giuseppe Tornatore who won an Oscar for Cinema Paradiso;

            

            Hollywood stars of Sicilian origin such as Frank Sinatra, Vincente Minnelli, Martin Scorsese, Frank Capra, Susan Sarandon, Cindy Lauper, Sylvester Stallone,  and Joseph Barbera;
            the impressive number of international directors who have chosen Sicily as a site for shooting their movies.

            

            As an enormous number of Sicilians and Sicilian descendants throughout the world are tired of the unjust association of their name with the Mafia, they hope to find a new cultural identity. Through Viscuso’s efforts, the Sicilian Film Festival has successfully achieved the correct formula where many people can unite in one project.

            

            While based primarily in Miami, the SFF holds events in both US and other cities worldwide. An official proclamation of a Sicilian Film Festival Day in 2007, recognized the cultural impact the Festival has had upon the City of Miami. When presenting Emanuele Viscuso with a Key to the City, Miami Beach Mayor Matti Bower said, “We appreciate the efforts of this Festival in bringing the Sicilian culture to the fore and sharing the beauty and life of Sicily with the people of Miami and the U.S.A. Through theater, music, art, and love, boundaries are traversed and all nations learn to share each others works and get to understand and appreciate different cultures.”

            

            In addition, the Italian region of Sicily bestowed upon Viscuso, the special honor of “Sicilians in the World: Ambassador of Culture” as a sign of its support of his efforts in establishing the Festival. This honor was received along with seventeen other people of Sicilian origin who represent different vocations and facets of Sicilian culture. Now, thanks to the efforts of the Sicilian Film Festival, Sicilian artists, both known and emerging, have a thriving opportunity in Miami Beach to display their genius to the world.

            

            The SFF is a Public Charity 501(c)(3) tax exempt organization.
            </h3>
          </h2>
      </div>
    </div>
    <div class="columns">
      <div class="column">
            <h1 id="miami" ref="miami">
                Miami House
            </h1>
            <br/><br/><br/><br/><br/>
          <h2 class="abouttext">
            <h3>
             <a href="http://www.themostbeautifulhouseintheworld.com/" target="_blank">Visit the website</a>
            <br/>
            There are 2 apartments in the villa: one at the second level, where the owner lives and manages the house and one for guests at garden level with 5 Bedrooms + Convertible bed(s), 4.5 Baths (Sleeps 12-15). This is the only offered to rental. Being guests in this house is a very special experience for people who love art, culture and the cozy style of an artistic Italian atmosphere. From this fortunate location you cannot see one building or any presence of a city but only bay, sky and tropical vegetation. A small, incredible sandy beach on the bay front and a typical gazebo complete the dream. The sunset is just in front. In the garden, next to the pool, you’ll find a tropical bar and a garden kitchen with a barbecue. In this little paradise you can rent a room or the whole house, if available, daily, weekly, monthly and long term at different prices. You can also rent the garden and the living areas for private and corporate parties, weddings etc. The 5 bedrooms are available to rent also separately (in case of partial rental other guests could stay in the house):

            • LIBRARY ROOM (double bed) side view and bathroom to share with Yellow Room
            • YELLOW ROOM (queen bed) side view and bathroom to share with Library Room
            • OCHER ROOM (double bed) bay front view and private bathroom
            • LEOPARD ROOM (queen bed) bay front view and private bathroom
            • IVY ROOM larger room (2 double beds) with side view and private bathroom

            The house is located in North Beach (entering from 77th St). 10 minutes from Bal Harbour, Florida most elegant shopping center, 5 minutes from oceanic beaches with natural park and 15 minutes from South Beach. Last but not least, the house has a high speed wireless internet connection and the street offers free parking.
            </h3>
          </h2>
        </div>
        <div class="column" style="min-height: 500px">
          <img
          class="bigimage"
            src="photos/miami1.png"
            alt="Emanuele Viscuso"
            align="left"
            style="margin: 50px 20px"
          /><br />
          <img
          class="midimage"
            v-prlx="{
              mobileMaxWidth: 500,
              speed: 0.2,
              fromBottom: false,
              preserveInitialPosition: true,
            }"
            src="photos/miami2.png"
            alt="Emanuele Viscuso"
            align="left"
            contain
            style="margin: -100px 0px"
          />
          <img
          class="bigimage"
            src="photos/miami3.png"
            alt="Emanuele Viscuso"
            align="right"
            contain
            style="margin: 10px -20px"
          /><br />
          <br />
        </div>
        
      </div>
      <div class="columns">
     
        <div class="column" style="min-height: 500px">
          <img
          class="bigimage"
            src="photos/chat-papa-francesco-bergoglio.jpg"
            alt="Emanuele Viscuso"
            align="left"
            style="margin: 50px 20px"
          /><br />
          <img
          class="midimage"
            v-prlx="{
              mobileMaxWidth: 500,
              speed: 0.2,
              fromBottom: false,
              preserveInitialPosition: true,
            }"
            src="photos/Pope_answer.jpg"
            alt="Emanuele Viscuso"
            align="left"
            contain
            style="margin: -100px 0px"
          />
          <img
          class="bigimage"
            src="photos/Pope.jpg"
            alt="Emanuele Viscuso"
            align="right"
            contain
            style="margin: 10px -20px"
          /><br />
          <br />

        </div>
         <div class="column">
            <h1 id="pope" ref="pope">
                Chat with Pope Francis
            </h1>
            <br/><br/><br/><br/><br/>
          <h2 class="abouttext">
            <h3>
            <a href="articles_pdf/Open_letter_of_Emanuele_Viscuso_to_Pope_Francesco_English.pdf" download="Open_letter_of_Emanuele_Viscuso_to_Pope_Francesco_English" target="_blank" >Open letter of Emanuele Viscuso</a>
            <br/>
            <a href="articles_pdf/Anwer_of_the_Pope_to_Emanuele_Viscuso.pdf" download="Anwer_of_the_Pope_to_Emanuele_Viscuso" target="_blank" >Answer of the Pope</a>
            <br/>
            Emanuele Viscuso, an Italian sculptor based in Miami, has done an amazing proposal to Pope Francis: to sell all the treasures of art owned by the Vatican and to do good with the proceeds of sales. The revolutionary idea continues with an even more revolutionary solution to allow the works of art sold remain where they are, ie in the Vatican Museums, therefore remaining heritage of humanity. In a private letter to His Holiness, Emanuele Viscuso also forewarned the Pope about his intention of sending to the media an open letter and so starting the process of a public debate about this delicate matter. Pope Francesco’s answer arrived only two weeks after he received the artist’s proposal. Through the Apostolic Nunciature in Washington, he wrote to Emanuele Viscuso to proceed with this journey of Good, True and Fine-looking, using the same words of the artists for explaining his proposal. The Pope continued entrusting this special intent of the artist to the maternal intercession of the Virgin Mary. You can read the original letter of Emanuele Viscuso to Pope Francis, the open letter for media and the response of the Pope, on the links below.
            </h3>
          </h2>
      </div>

    </div>
    </div>
    
</template>

<script>
export default {
  name: "Stories",
  components: {},
  computed: {},
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName];
      el.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #040303;
  background-attachment: fixed;
  background-size: cover;
  color: #fff;
}

.link {
  color: #9dc7de;
  transition: 0.3s color ease;

  &:hover {
    color: #e48353;
  }
}

a {
  color: #9dc7de;
  transition: 0.3s color ease;
}
a:hover {
  color: #e48353;
}
.bigimage {
  width: 80%;
}

.midimage {
  width: 50%;
}

.abouttext {
  font-family: "Helvetica";
  font-size: 1.8em;
  text-align: justify;
}

h1 {
  font-family: "Helvetica";
  font-size: 2em;
  font-weight: bold;
  margin-top: 2rem;
  z-index: 10;
  position: absolute;
}
</style>
